import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IParametresRechercheService } from '../../../../../core/services/parametres-recherche.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IStateParamsService } from 'angular-ui-router';
import { IWindowService } from 'angular';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IOperateurService } from '../../../../../core/services/operateur.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';

interface IPageAL0005 {
    multiOccurrence: IMultiOccurrence;
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
    eplnummat: string;
}

/* @ngInject */
export default function Al0005Controller(MenuItemEcran: IMenuItemEcranClass,
    Menu: IMenuClass,
    $window: IWindowService,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    al0002Route: IRoute,
    al2013Route: IRoute,
    exDateFilter: IFilterExDate,
    MenuItemForage: IMenuItemForageClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    $stateParams: IStateParamsService,
    parametresRecherche: IParametresRechercheService,
    Pagination: IPaginationClass,
    Operateur: IOperateurService) {

    const vm: IPageAL0005 = this;
    const filtresParametres = [];

    // Applique un filtre si l'écran est appelé par as0034
    if ($stateParams.eplnummat) {
        filtresParametres.push(
            ...[
                {
                    colonne: 'eplnummat',
                    operateur: Operateur.EGALE,
                    valeur: $stateParams.eplnummat,
                    readOnly: true
                }
            ]
        );
    }

    // @TODO ajouter la route de forage une fois que l'écran est fait

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        actionsMore: new Menu([
            new MenuItemEcran(
                'LBL_CRI_AFF',
                al2013Route.NAME,
                () => ({}),
                {
                    icon: 'view_list',
                    iconButton: false,
                    onClose() {
                        // pas le choix d'un reload, car on change possiblement les
                        // valeurs pour le hidden des colonnes daldatflx*
                        // et aussi les libellés dynamiques
                        $window.location.reload();
                    }
                }
            )
        ]),
        filtresParametres,
        criteresSuggeres: new Formulaire([
            new FormulaireItem('demcleint', { largeur: 35 }),
            new FormulaireItem('dalcleint', { largeur: 35 }),
            new FormulaireItem('datref', { largeur: 25, default: exDateFilter(new Date()) }),
            new FormulaireItemDivider('LBL_CRI_PRO'),   // Profil
            new FormulaireItem('prfcleint', { lovSelectionMultiple: true,largeur: 25 }),
            new FormulaireItem('prfdatdebcri', { largeur: 15 }),
            new FormulaireItem('prfdatfincri', { largeur: 15 }),
            new FormulaireItemDivider('LBL_CRI_TIN'),   // Type d'intervalle
            new FormulaireItem('vaccleint', { lovSelectionMultiple: true, largeur: 25 }),
            new FormulaireItem('vacdatdebcri', { largeur: 15 }),
            new FormulaireItem('vacdatfincri', { largeur: 15 }),
            new FormulaireItemDivider('LBL_CRI_AVI'),   // Avis
            new FormulaireItem('apccleint', { lovSelectionMultiple: true, largeur: 25 }),
            new FormulaireItem('apcdatdebcri', { largeur: 15 }),
            new FormulaireItem('apcdatfincri', { largeur: 15 })
        ]),        
        navigatePage: al0002Route.NAME,
        actionsNouveaux: new Menu([
            new MenuItemForage(al0002Route.NAME, () => {
                return {
                    demcleint: $stateParams.employe,
                    fonction: 'BOUNOUV',
                    icon: ''
                };
            })
        ]),

        pagination: new Pagination({
            nombreElementPage: 100,
            nbElementsPossibles: [100, 250, 500]
        }),
        filtres: parametresRecherche(ecranDetails),
        colonnesFixesGauche: [
            { nom: 'eplnummat', largeur: 100, hidden: $stateParams.employe },
            { nom: 'eplnomprn', largeur: 262, hidden: $stateParams.employe }
        ],
        colonnesVisibles: [
            { nom: 'dalnumdoc', largeur: 100 },
            { nom: 'tdlcod', largeur: 140 },
            { nom: 'tdldsc', largeur: 250 },
            { nom: 'ecldsceta', largeur: 250 },
            { nom: 'urgcod', largeur: 220 },
            { nom: 'urgdscabr', largeur: 270 },
            { nom: 'strcod', largeur: 155 },
            { nom: 'strdsc', largeur: 250 },
            { nom: 'prfcod_dal', largeur: 120 },
            { nom: 'prfdscabr', largeur: 250 },
            { nom: 'dlddat', largeur: 150 },
            { nom: 'alidsc', largeur: 250 },
            { nom: 'vacvalcle', largeur: 200 },
            { nom: 'vacdsc', largeur: 270 },
            { nom: 'daldatouv', largeur: 100 },
            { nom: 'daldatdeb', largeur: 100 },
            { nom: 'daldatret', largeur: 120 },
            { nom: 'daldatretprg', largeur: 130 },
            { nom: 'daldatfer', largeur: 100 },
            { nom: 'daldatrec', largeur: 100 },
            { nom: 'daldatflx1', largeur: 150, hidden: () => ecranDetails.valeurs.datflx1 === 0},
            { nom: 'daldatflx2', largeur: 150, hidden: () => ecranDetails.valeurs.datflx2 === 0},
            { nom: 'daldatflx3', largeur: 150, hidden: () => ecranDetails.valeurs.datflx3 === 0},
            { nom: 'daldatflx4', largeur: 150, hidden: () => ecranDetails.valeurs.datflx4 === 0},
            { nom: 'daldatflx5', largeur: 150, hidden: () => ecranDetails.valeurs.datflx5 === 0},
            { nom: 'dalprcdif', largeur: 180 },
            { nom: 'ttccod', largeur: 110 },
            { nom: 'ttcdsc', largeur: 270 },
            { nom: 'dalcom', largeur: 500, hidden: !ecranDetails.valeurs.flgcom },
            { nom: 'trnflgstaref', largeur: 100 },
            { nom: 'trnflgstafin', largeur: 100 },
            { nom: 'trnflgstafer', largeur: 100 },
            { nom: 'trnflgstaann', largeur: 100 }
        ]
    };
}
